<template>
  <div class="section-page">
    <BaseTypePageCap
      v-if="!hideHeader"
      :icon="sectionConfig.icon"
      :back-label="sectionConfig.label"
      :back-route-name="sectionConfig.indexRoute"
      :show-back-link="showBackLink"
      :title="title"
      :subtitle="subtitle"
      neutral
    >
      <template v-if="$slots.title" #title>
        <slot name="title" />
      </template>
      <template v-if="$slots['header-actions']" #header-actions>
        <slot name="header-actions" />
      </template>
    </BaseTypePageCap>
    <div class="section-page__body">
      <slot />
    </div>
  </div>
</template>

<script>
import {PAGE_SECTIONS} from "@/constants/pageSections";
import BaseTypePageCap from "@/components/base_type/BaseTypePageCap.vue";

export default {
  name: 'SectionPageShell',
  components: {
    BaseTypePageCap,
  },
  props: {
    section: {
      type: String,
      required: true,
      validator: (value) => Object.prototype.hasOwnProperty.call(PAGE_SECTIONS, value),
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: null,
    },
    showBackLink: {
      type: Boolean,
      default: false,
    },
    hideHeader: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    sectionConfig() {
      return PAGE_SECTIONS[this.section]
    },
  },
}
</script>
